import { render, staticRenderFns } from "./broadcastBar.vue?vue&type=template&id=6896a14a&scoped=true"
import script from "./broadcastBar.vue?vue&type=script&lang=js"
export * from "./broadcastBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896a14a",
  null
  
)

export default component.exports